class ModalToggle extends HTMLElement {
  constructor() {
    super();
    this.toggleModal = this.toggleModal.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.active = this.classList.contains("active");
  }

  get target() {
    return this.getAttribute("data-set-target");
  }

  get modalContainer() {
    return document.getElementById(this.target);
  }

  toggleModal() {
    const toggles = document.querySelectorAll("modal-toggle");
    const isExpanding = !this.modalContainer?.classList.contains("expanded");
    const isActive = this.classList.contains("active") || this.modalContainer?.classList.contains("expanded");

    toggles.forEach((toggle) => {
      if (toggle !== this) {
        toggle.close();
        if (toggle.target === this.target) {
          toggle.active = isExpanding;
          toggle.classList.toggle("active", isExpanding);
        }
      }
    });

    this.active = !isActive;
    this.classList.toggle("active", this.active);
    if (this.modalContainer) {
      this.modalContainer.classList.toggle("expanded", this.active);
    }

    if (this.closest('.cart-dropdown') || this.dataset.setTarget === 'cart-dropdown') {
      let deliveryDesktop = document.querySelector('.header-delivery__desktop');
      if (deliveryDesktop) {
        if (this.active) {
          deliveryDesktop.classList.add('hidden');
        } else {
          deliveryDesktop.classList.remove('hidden');
        }
      } 
    }

    if (this.active) {
      document.addEventListener("click", this.handleOutsideClick);
    } else {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }

  close() {
    this.active = false;
    this.classList.remove("active");
    if (this.modalContainer) {
      this.modalContainer.classList.remove("expanded");
      if (this.closest('.cart-dropdown') || this.dataset.setTarget === 'cart-dropdown') {
        let deliveryDesktop = document.querySelector('.header-delivery__desktop');
        if (deliveryDesktop) {
          deliveryDesktop.classList.remove('hidden');
        } 
      }
    }
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    const clickedInsideModal = this.modalContainer?.contains(e.target);
    const clickedToggleItself = this.contains(e.target);

    if (!clickedInsideModal && !clickedToggleItself) {
      this.close();
    }
  }

  handleKeyDown(e) {
    if (e.key === "Escape") {
      this.close();
    }
  }

  connectedCallback() {
    this.addEventListener("click", this.toggleModal);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.toggleModal);
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("click", this.handleOutsideClick);
  }
}

customElements.define("modal-toggle", ModalToggle);
